import React, { useState } from "react";
import { getStatusText } from "../utils/statusUtils"; // Assuming you have this
import { useToast } from "../context/ToastContext";

const ManagerActionButtons = ({
  currentStatusId,
  onApprove,
  onReject,
  onResent,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(null);
  const [showRemarksDialog, setShowRemarksDialog] = useState(null);
  const [remarks, setRemarks] = useState("");
  const toast = useToast();

  const handleActionClick = (action) => {
    setShowConfirmation(action);
  };

  const handleConfirmation = (confirmed) => {
    setShowConfirmation(null);
    if (confirmed) {
      switch (showConfirmation) {
        case 6: // Approved
          onApprove();
          break;
        case 7: // Rejected
          setShowRemarksDialog(7);
          break;
        case 8: // Resent
          setShowRemarksDialog(8);
          break;
        default:
          break;
      }
    }
  };

  const handleRemarksSubmit = () => {
    if (remarks.trim()) {
      switch (showRemarksDialog) {
        case 7:
          if (onReject) onReject(remarks);
          break;
        case 8:
          if (onResent) onResent(remarks);
          break;
        default:
          break;
      }
      setShowRemarksDialog(null);
      setRemarks("");
    } else {
      toast.error("Remarks cannot be empty.");
    }
  };

  const handleRemarksCancel = () => {
    setShowRemarksDialog(null);
    setRemarks("");
  };

  return (
    <div>
      <button
        onClick={() => handleActionClick(6)}
        className="bg-green-500 hover:bg-green-700 text-white py-2 px-4 rounded mr-2 cursor-pointer"
      >
        Approve
      </button>
      <button
        onClick={() => handleActionClick(7)}
        className="bg-red-500 hover:bg-red-700 text-white py-2 px-4 rounded mr-2 cursor-pointer"
      >
        Reject
      </button>
      <button
        onClick={() => handleActionClick(8)}
        className="bg-orange-500 hover:bg-orange-700 text-white py-2 px-4 rounded cursor-pointer"
      >
        Resend
      </button>

      {/* Confirmation Dialog */}
      {showConfirmation && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-md shadow-lg w-100">
            <p className="mb-4">
              Are you sure you want to{" "}
              {getStatusText(showConfirmation).toLowerCase()} this form?
            </p>
            <div className="flex justify-end">
              <button
                onClick={() => handleConfirmation(false)}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded mr-2 cursor-pointer"
              >
                Cancel
              </button>
              <button
                onClick={() => handleConfirmation(true)}
                className={`bg-${
                  showConfirmation === 6
                    ? "green"
                    : showConfirmation === 7
                    ? "red"
                    : "orange"
                }-500 hover:bg-${
                  showConfirmation === 6
                    ? "green"
                    : showConfirmation === 7
                    ? "red"
                    : "orange"
                }-700 text-white py-2 px-4 rounded cursor-pointer`}
              >
                Confirm {getStatusText(showConfirmation)}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Remarks Dialog */}
      {showRemarksDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-md shadow-lg w-200">
            <h2 className="text-lg mb-4">Add Remarks</h2>
            <textarea
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              className="w-full h-24 p-2 border rounded-md mb-4"
              placeholder="Enter your remarks here..."
            />
            <div className="flex justify-end">
              <button
                onClick={handleRemarksCancel}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded mr-2 cursor-pointer"
              >
                Cancel
              </button>
              <button
                onClick={handleRemarksSubmit}
                className={`bg-${
                  showRemarksDialog === 7 ? "red" : "orange"
                }-500 hover:bg-${
                  showRemarksDialog === 7 ? "red" : "orange"
                }-700 text-white py-2 px-4 rounded cursor-pointer`}
              >
                Submit Remarks
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagerActionButtons;
